import { faHome, faPlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect, useState } from "react";
import {Pagination} from "../../components/Pagination";
import { Breadcrumb, ButtonGroup, Card, Tab, Table, Tabs } from "react-bootstrap";
import { Link } from "react-router-dom";
import OffersActions from "../libs/Offers";
import CustomSpinner from "../../components/CustomSpinner";
import OfferTable from "../../components/OfferTable";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import {getOffersData} from "../../store/actions/offer";
import { getCompanySettings } from "../../store/actions/settings";
import Messages from "../../components/Messages";
import {extractPaginationData} from "../../libs/pagination";

export default function Offers() {
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [activeTab, setActiveTab] = useState('all');
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [offers, setOffers] = useState([]);
  const [paginationData, setPaginationData] = useState({
    links: [],
    prevPageUrl: "",
    nextPageUrl: "",
    showingPerPgae: "",
    total: "",
  });

  useEffect(() => {
    dispatch(getOffersData())
    dispatch(getCompanySettings());

    // eslint-disable-next-line
  }, [dispatch]);

  useEffect(() => {
    getPaginatedOffers(page);
  }, [page, activeTab]);


  const getPaginatedOffers = (page = 1) => {
    setLoading(true);
    OffersActions.getPaginatedOffers(page)
        .then((res) => {
          setOffers(res);
          setLoading(false);
          const activeTabConfig = tabsConfig.find(tab => tab.eventKey === activeTab);
          const statusData = res?.[activeTabConfig?.dataKey];

          setPaginationData(extractPaginationData(statusData));
        })
        .catch((error) => {
          setLoading(false);
        });
  };

  const countOffersByStatus = (dataKey) => {
    return offers?.[dataKey]?.total || 0;
  };


  const tabsConfig = [
    { eventKey: "all", label: t("All"), dataKey: "all" },
    { eventKey: "open", label: t("Sent"), dataKey: "open" },
    { eventKey: "accepted", label: t("Agree"), dataKey: "accepted" },
    { eventKey: "draft", label: t("Draft"), dataKey: "draft" },
  ];

  return (
    <div className=" py-4">
      <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center">
        <div>
          <Breadcrumb
            listProps={{ className: "breadcrumb-dark breadcrumb-transparent" }}
          >
            <Breadcrumb.Item href="/">
              <FontAwesomeIcon icon={faHome} />
            </Breadcrumb.Item>
            <Breadcrumb.Item active>{t("offers")}</Breadcrumb.Item>
          </Breadcrumb>
          <h4>{t("offers")}</h4>
          <p>{t("Show your Offers")}</p>
        </div>
        <div className="btn-toolbar mb-2 mb-md-0">
          <ButtonGroup>
            <Link to="create-offer" className="btn btn-outline-primary btn-sm">
              <FontAwesomeIcon icon={faPlus} className="me-2" /> {t("new")}
            </Link>
          </ButtonGroup>
        </div>
      </div>

        <div className="row">
            <div className="col-md-12">
                <Messages/>
            </div>
        </div>

      <div style={{ backgroundColor: '#fff', borderRadius: '10px' }}>
        <Tabs
            defaultActiveKey="all"
            id="offer-tabs"
            style={{ padding: '8px' }}
            activeKey={activeTab}
            onSelect={(k) => {
              setActiveTab(k);
              setPage(1);
            }}
        >
          {tabsConfig.map(({ eventKey, label, dataKey }) => (
              <Tab
                  key={eventKey}
                  eventKey={eventKey}
                  title={`${label} (${countOffersByStatus(dataKey)})`}
              >
                {loading ? (
                    <CustomSpinner />
                ) : (
                    <Card border="light" className="table-wrapper table-responsive shadow-sm">
                      <Card.Body className="pt-0 pb-5">
                        <Table hover className="user-table align-items-center">
                          <thead>
                          <tr>
                            <th className="border-bottom">#</th>
                            <th className="border-bottom">{t("Offer Date")}</th>
                            <th className="border-bottom">{t("Offer Number")}</th>
                            <th className="border-bottom">{t("customer name")}</th>
                            <th className="border-bottom">{t("status")}</th>
                            <th className="border-bottom">{t("price")}</th>
                            <th className="border-bottom">{t("action")}</th>
                          </tr>
                          </thead>
                          <tbody>
                          {offers?.[dataKey]?.data?.map((offer, index) => (
                              <OfferTable
                                  key={offer.id || offer.uuid || index}
                                  index={index}
                                  {...offer}
                                  setPaginationData={setPaginationData}
                                  setLoading={setLoading}
                                  paginationData={paginationData}
                                  getPaginatedOffers={getPaginatedOffers}
                              />
                          ))}
                          </tbody>
                        </Table>
                        <Pagination
                            page={page}
                            setPage={setPage}
                            {...paginationData}
                        />
                      </Card.Body>
                    </Card>
                )}
              </Tab>
          ))}
        </Tabs>
      </div>
    </div>
  );
}
